import {z} from 'zod'

export const zViewActivity = z.object({
  type: z.literal('view'),
  path: z.string().optional(),
  query: z.object({}).optional()
})
export type ViewActivity = z.infer<typeof zViewActivity>

export const zProfileActivity = z.object({
  type: z.literal('profile_created'),
  profile_id: z.string(),
  workspace_id: z.string(),
  roles: z.array(z.string()).optional(),
  is_restored: z.boolean(),
  source: z.enum(['create_for_global', 'create_from_ws_invite', 'create_from_domain', 'create_from_user_invite'])
})
export type ProfileActivity = z.infer<typeof zProfileActivity>

export const zActivityCfg = z.discriminatedUnion('type', [zViewActivity, zProfileActivity])

export type ActivityCfg = z.infer<typeof zActivityCfg>
export const zActivityRow = z.object({
  id: z.string(),
  workspace_id: z.string(),
  created_at: z.string(),
  profile_id: z.string(),
  question_id: z.string().optional(),
  type: z.string(),
  cfg: zActivityCfg
})
